// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn genDocRefEligibleEntityTypes.
//
// This file is generated from:
// - Static direct/embedded entities in packages/building-types/entities/docRefDirectEligibleEntities.ts
// - Constraint definitions in packages/building-types/doc/docEntityConstraints.ts
import type { DocEntityType } from "building-types/doc/docEntityTypes";

/**
 * Runtime object for indirect doc ref eligible entity types.
 * This object is the source of truth - types in building-types are derived from it.
 *
 * @see ./DocRefEligibleEntityTypes.md for detailed guidance on how eligibility
 * categories are computed.
 */
export const docRefIndirectEligibleEntities = {
  ANNOTATION: true,
  ASSET: true,
  BLOCK: true,
  CASEWORK: true,
  CEILING: true,
  COLUMN: true,
  COMPONENT_INSTANCE: true,
  COMPOSITE_LEVEL: true,
  CONTENT_REPLICATOR: true,
  CONTENT_TEMPLATE_INSTANCE: true,
  DATA_TABLE: true,
  DRAWING_REF: true,
  EDGE_BEHAVIOR: true,
  EDGE_MODIFIER: true,
  EFFECT: true,
  ENTITY_SETTINGS: true,
  FACADE_SPAN_STRATUM: true,
  FACADE_SWEEP_STRATUM: true,
  FLOOR: true,
  FLOOR_FINISH: true,
  FLOOR_SYSTEM: true,
  FOUNDATION: true,
  FOUNDATION_SYSTEM: true,
  INSTANCE_OPTION_SET: true,
  LEVEL: true,
  LOCAL_PARAMETER: true,
  OPENING: true,
  OPTION_EFFECT: true,
  OPTION_SET_OVERRIDES: true,
  PLAN_SET_TEMPLATE_CONFIG: true,
  PROP_INSTANCE: true,
  RAILING: true,
  RAILING_SETTING: true,
  REPORTABLE_UNIT_DESIGNATION: true,
  ROOF: true,
  ROOF_OPENING: true,
  ROOF_SYSTEM: true,
  ROOM: true,
  ROOM_LAYOUT_INSTANCE: true,
  RULE_BASED_SELECTOR_INSTANCE: true,
  SETTINGS: true,
  SITE_SHAPE: true,
  SKYLIGHT: true,
  STAIR_BLOCK: true,
  STAIR_SYSTEM: true,
  UNDERLAY: true,
  VIEW_3D: true,
  VIEWPORT: true,
} as const satisfies Partial<Record<DocEntityType, true>>;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn genDocRefEligibleEntityTypes.
//
// This file is generated from:
// - Static direct/embedded entities in packages/building-types/entities/docRefDirectEligibleEntities.ts
// - Constraint definitions in packages/building-types/doc/docEntityConstraints.ts
